import React from 'react'
import { default as Spinner } from 'react-loader-spinner'

interface ILoaderProps {
  visible?: boolean
  type:
    | 'Audio'
    | 'BallTriangle'
    | 'Bars'
    | 'Circles'
    | 'Grid'
    | 'Hearts'
    | 'Oval'
    | 'Puff'
    | 'Rings'
    | 'TailSpin'
    | 'ThreeDots'
    | 'Watch'
    | 'RevolvingDot'
    | 'Triangle'
    | 'Plane'
    | 'MutatingDots'
    | 'CradleLoader'
  height?: number | string
  width?: number | string
  color?: string
  secondaryColor?: string
  timeout?: number
  radius?: number
  className?: string
}

const Loader: React.FC<ILoaderProps> = ({ className, ...props }) => {
  if (!props.visible) {
    return null
  }
  return (
    <div className={className}>
      <Spinner {...props} />
    </div>
  )
}

export default Loader
